module.exports = __webpack_public_path__ + "media/promo/panasonic/images/soc-2-ada32bfc9405934284259fa3dacc1e65.svg";